// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"246ad1e6","963":"5749b096"}[chunkId] + ".chunk.js";
};